/// <reference types="google.maps" />
import { useMap } from "@vis.gl/react-google-maps";
import { type Ref, useImperativeHandle } from "react";

/** Props Interface */
export interface MapViewHandle {
	panTo: (center: { lat: number; lng: number }) => void;
	setCenter: (center: { lat: number; lng: number }) => void;
	setZoom: (zoom: number) => void;
	fitBounds: (bounds: google.maps.LatLngBoundsLiteral) => void;
	getMap: () => google.maps.Map | null;
}

interface MapViewImperativeHandleProps {
	handleRef: Ref<MapViewHandle>;
}

export function MapViewImperativeHandle({ handleRef }: MapViewImperativeHandleProps) {
	/** Hooks */
	const map = useMap();

	/** Effects */
	useImperativeHandle(
		handleRef,
		() => ({
			panTo: (center) => map?.panTo(center),
			setCenter: (center) => map?.setCenter(center),
			setZoom: (zoom) => map?.setZoom(zoom),
			fitBounds: (bounds) => map?.fitBounds(bounds),
			getMap: () => map ?? null,
		}),
		[map],
	);

	/** Render */
	return null;
}
